// tippi/src/components/common/BroadcastModal.js
import React from 'react';
import { useBroadcasts } from '../../contexts/BroadcastsContext';
import { COLORS, SHADOWS } from '../../styles/tokens';

export default function BroadcastModal() {
  const { modalBroadcast, dismiss } = useBroadcasts();
  if (!modalBroadcast) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.tag}><span aria-hidden="true">⚡ </span>Melding fra Tippi</div>
        <h2 style={styles.title}>{modalBroadcast.title}</h2>
        <p style={styles.body}>{modalBroadcast.body}</p>
        <button style={styles.btn} onClick={() => dismiss(modalBroadcast.id)}>
          Forstått
        </button>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1000,
  },
  modal: {
    background: COLORS.white, borderRadius: 24, padding: '28px 24px',
    maxWidth: 440, width: '90%', boxShadow: SHADOWS.lg,
  },
  tag: {
    display: 'inline-block', fontSize: 12, fontWeight: 700,
    color: '#fdc149', background: '#1a1a2e', borderRadius: 20,
    padding: '6px 12px', marginBottom: 14,
  },
  title: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 32, lineHeight: 1.05, fontWeight: 700, color: COLORS.textDark, margin: '0 0 10px' },
  body:  { fontSize: 15, color: COLORS.textMid, lineHeight: 1.6, margin: '0 0 24px', whiteSpace: 'pre-wrap' },
  btn:   {
    width: '100%', height: 52, border: 'none',
    background: '#1a1a2e', color: '#fff', borderRadius: 26,
    fontSize: 15, fontWeight: 600, cursor: 'pointer',
  },
};
